import { useState } from "react";
import type { TasksLanding } from "@components/tasks/tasksLanding";
import { useClientTasksLink } from "./useClientTasksLink";
import { useOrganizationTasksLanding } from "./useOrganizationTasksLanding";

/**
 * The landing the org Tasks page content mounts with, or `null` while the
 * page should show its loader: until the landing resolves, and while a
 * `?clientId=` link is applied, so the content remounts and reads the client's
 * clean landing. After a client link it lands on the linked view, or none.
 */
export function useOrganizationTasksPageLanding(): TasksLanding | null {
    const resolvedLanding = useOrganizationTasksLanding();
    const [landing, setLanding] = useState(resolvedLanding);
    const { isApplyingClientLink, clientLanding } = useClientTasksLink();

    if (landing === null && resolvedLanding !== null) {
        setLanding(resolvedLanding);
    }

    if (!landing || isApplyingClientLink) {
        return null;
    }

    return clientLanding ?? landing;
}
